<template lang="">
  <div>
    <div class="container">
      <div class="main-result">
        <Form :model="formItem" :label-width="80">
          <FormItem label="企业代码">
            <Input
              @click="SelectClientSwitch = !SelectClientSwitch"
              v-model="formItem.clientCode"
              type="text"
              placeholder="企业代码"
            ></Input>
          </FormItem>
          <FormItem label="名称">
            <Input
              v-model="formItem.user_name"
              type="text"
              placeholder="名称"
            ></Input>
          </FormItem>

          <FormItem label="手机号">
            <Input
              v-model="formItem.user_phone"
              type="text"
              placeholder="手机号"
            ></Input>
          </FormItem>

          <FormItem label="登录密码">
            <Input
              v-model="formItem.user_password"
              type="password"
              :autosize="{ minRows: 2, maxRows: 5 }"
              placeholder="登录密码"
            ></Input>
          </FormItem>

          <FormItem label="所属仓库">
            <Input
              v-model="formItem.store_name"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 5 }"
              placeholder="所属仓库"
            ></Input>
          </FormItem>

          <FormItem label="备注">
            <Input
              v-model="formItem.remark"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 5 }"
              placeholder="备注"
            ></Input>
          </FormItem>

          <FormItem>
            <Button type="primary" @click="updatas()">提交</Button>
          </FormItem>
        </Form>
      </div>
    </div>

    <SelectClient
      v-if="SelectClientSwitch"
      @Value="SelectClientVal"
      @close="SelectClientClose"
    ></SelectClient>
  </div>
</template>
<script>
// id  clientCode  user_name  user_phone   user_password  store_code  store_name  time        remark
import { setStoraUserList } from "@/api/index";
import SelectClient from "@/views/selectClient";
export default {
  data() {
    return {
      SelectClientSwitch: false,
      formItem: {
        clientCode: "",
        remark: "",
        store_name: "",
        user_name: "",
        user_phone: "",
        user_password: "",
        store_code: "",
      },
    };
  },
  components: {
    SelectClient,
  },
  beforeCreate() {},
  mounted() {},
  updated() {},
  watch: {},
  methods: {
    SelectClientClose() {
      this.SelectClientSwitch = false;
    },
    SelectClientVal(value) {
      this.formItem.clientCode = value;
      this.SelectClientSwitch = false;
    },
    updatas() {
      setStoraUserList({
        obj: this.formItem,
      }).then((res) => {
        if (res.code == 402) {
          this.$Notice.error({ title: "没有权限！" });
        }
        if (res == 1) {
          this.$emit("addResultList", this.formItem);
        }
      });
    },
  },
};
</script>
<style scoped >
.top {
  width: 100%;
  background: white;
  padding: 15px;
  display: flex;
  flex-direction: row;
}

.select {
  margin-left: 10px;
}

.main {
  background: white;
  display: flex;
  flex-direction: column;
  align-items: left;
}

.page {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
